import React from 'react';
import { NewCareerPositionProvider } from 'contexts/career-position.context';
import CareerContent from './content';

const CareerLayout = () => {
  return (
    <NewCareerPositionProvider>
      <CareerContent />
    </NewCareerPositionProvider>
  );
};

export default CareerLayout;
